var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "variation-list-item", attrs: { "two-line": "" } },
    [
      _c("div", { staticClass: "variation-list-item-content" }, [
        _c(
          "div",
          { staticClass: "variation-header" },
          [
            _c("v-list-item-title", [
              _vm._v(
                "Data: " +
                  _vm._s(
                    _vm._f("formatDateTime")(_vm.variazione.dateTracking)
                  ) +
                  " "
              ),
            ]),
            _c(
              "v-btn",
              {
                staticStyle: { color: "white" },
                attrs: { color: "green lighten-2" },
                on: {
                  click: function ($event) {
                    return _vm.confermaVariazione()
                  },
                },
              },
              [_vm._v(" Conferma variazione ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "difference-list" },
          _vm._l(_vm.variazione.differences, function (difference, i) {
            return _c(
              "div",
              { key: i, staticClass: "difference-item" },
              [
                _c("v-icon", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(" mdi-chevron-right"),
                ]),
                _c("div", [
                  _vm._v(" E' stata variata la proprietà "),
                  _c("strong", [
                    _vm._v('"' + _vm._s(difference.propertyName) + '"'),
                  ]),
                  _vm._v(" da "),
                  _c("strong", [
                    _vm._v(
                      '"' +
                        _vm._s(
                          _vm.formatValue(
                            difference.oldValue,
                            difference.propertyType
                          )
                        ) +
                        '"'
                    ),
                  ]),
                  _vm._v(" a "),
                  _c("strong", [
                    _vm._v(
                      '"' +
                        _vm._s(
                          _vm.formatValue(
                            difference.newValue,
                            difference.propertyType
                          )
                        ) +
                        '"'
                    ),
                  ]),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }